// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"StockDashboard_dashboardContainer__3cVJD"};